import React, { useEffect, useState, useCallback } from "react";
import { Button } from "@telegram-apps/telegram-ui";
import { useNavigate } from "react-router-dom";
import { TemporaryCoinsService } from "../../services/TemporaryCoinsService";
import { StorageService } from "../../services/LocalStorageService";
import { getRankForDollars } from "./rankConfig";
import "./SimpleMenu.css";

export function SimpleMenu(): JSX.Element {
  const navigate = useNavigate();
  const [dollars, setDollars] = useState<number>(
    TemporaryCoinsService.getCoins()
  );
  const [dailyMaxRounds, setDailyMaxRounds] = useState<number>(
    StorageService.getDailyMaxRounds()
  );
  const [gems, setGems] = useState<number>(StorageService.getTotalGems());
  const TEMPORARY_COINS_STORAGE_KEY = "temporary_coins";
  const DAILY_MAX_ROUNDS_STORAGE_KEY = "daily_max_rounds_value";
  const GEMS_STORAGE_KEY = "gems_total";

  const refreshBalance = useCallback(() => {
    setDollars(TemporaryCoinsService.getCoins());
  }, []);

  useEffect(() => {
    // Sync with changes made in other tabs or flows
    const onStorage = (e: StorageEvent) => {
      if (
        e.key === TEMPORARY_COINS_STORAGE_KEY ||
        e.key === DAILY_MAX_ROUNDS_STORAGE_KEY ||
        e.key === GEMS_STORAGE_KEY ||
        e.key === null
      ) {
        // key may be null on clear(); refresh defensively
        refreshBalance();
        setDailyMaxRounds(StorageService.getDailyMaxRounds());
        setGems(StorageService.getTotalGems());
      }
    };
    window.addEventListener("storage", onStorage);

    // Also refresh once on mount in case default was set
    refreshBalance();
    setDailyMaxRounds(StorageService.getDailyMaxRounds());
    setGems(StorageService.getTotalGems());
    return () => window.removeEventListener("storage", onStorage);
  }, [refreshBalance]);

  const handleStart = useCallback(() => {
    navigate("/game");
  }, [navigate]);

  return (
    <div className="simple-menu" role="main" aria-label="Simple Menu">
      <div className="simple-menu__content">
        <div className="simple-menu__balance" aria-live="polite">
          You have ${dollars}
        </div>
        {(() => {
          const rank = getRankForDollars(dollars);
          return (
            <div className="simple-menu__rank">
              You are <span style={{ color: rank.colorHex }}>{rank.name}</span>
            </div>
          );
        })()}
        <div className="simple-menu__max-rounds" aria-live="polite">
          Max rounds today: {dailyMaxRounds}
        </div>
        <div className="simple-menu__gems" aria-live="polite">
          You have {gems} gems
        </div>
        
        <Button
          size="l"
          className="simple-menu__start"
          onClick={handleStart}
          stretched
        >
          START
        </Button>
      </div>
    </div>
  );
}
